import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import SubscriptionID from '@/App/Subscription/Entity/SubscriptionID'
import type {
    SubscriptionData,
    SubscriptionStatusEnum,
} from '@/Shared/AutoGenerated/Main'

export default class Subscription {
    constructor(
        public readonly id: SubscriptionID,
        public readonly status: SubscriptionStatusEnum,
        public readonly subscribedAt: string | null,
        public readonly canceledAt: string | null,
        public readonly gracePeriodEndsAt: string | null,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: SubscriptionData): Subscription {
        return new Subscription(
            new SubscriptionID(entityData.id),
            entityData.status,
            entityData.subscribedAt,
            entityData.canceledAt,
            entityData.gracePeriodEndsAt,
        )
    }

    static hydrateMultiple(entitiesData: SubscriptionData[]): Subscription[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
